export default "__VITE_ASSET__DtsFUyS___"